<template>
	<div class="card-item-wrapper p-d-12" @click="detail">
		<div class="card-item">
			<div class="top-card">
				<div class="f-semi f-16 f-c-black">{{ paket.nama_paket_deposit }}</div>
				<div class="card-chevron"></div>
			</div>
			<div class="f-regular f-13 f-c-midgrey m-t-4">
				<img src="../../../assets/icons/file.svg" alt="">
				{{ paket.nama_layanan }}
			</div>
			<div class="f-regular f-13 f-c-midgrey m-t-4">
				<img src="../../../assets/icons/outlet-out-muted.svg" alt="">
				{{ paket.nama_outlet }}
			</div>

			<div class="separator-line m-x-min m-t-10"></div>
			<div class="bottom-card m-t-8 d-flex-between-center align-items-center">
				<div class="f-14">
					<span class="f-regular f-c-midgrey">Kuota </span>
					<span class="f-semi f-c-black">{{ formatRupiah(paket.kuota.toString()) }} {{ paket.satuan }}</span>
				</div>
				<div class="f-regular f-12 f-c-midgrey" v-if="!isExpired">
					Aktif {{ paket.masa_aktif === 'Selamanya' ? 'Selamanya' : 'hingga ' + paket.masa_aktif }}
				</div>
				<div class="f-regular f-12 f-c-midgrey" v-else>
					<i>Kedaluwarsa {{ paket.masa_aktif }}</i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOCardPaketDeposit",
	props: {
		paket: Object,
		isExpired: Boolean,
	},
	methods: {
		detail(payload) {
			this.$emit("detail", payload)
		}
	}
}
</script>